import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table, Input, Select, Tooltip, Tag, Spin } from "antd";
import { Collapse } from "antd";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
const { Panel } = Collapse;

const ViewRFQSteel = ({RFQMaterialDetails1}) => {
  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [btnLoading, setBtnLoading] = useState(false);
  const { t } = useTranslation();
  const { responseId } = useParams();
  const [tableData, setTableData] = useState([]);
  const [rfqMaterialDetailsID, setRfqMaterialDetailsID] = useState(false);
  const [response, setResponse] = useState(null);
  const [diameterList, setDiameterList] = useState([]);

  const [state, setState] = useState([]);
  const [masterId, setMasterId] = useState(null);
  const [cityLength, setCityLength] = useState(1);
  const [apiLoading, setapiLoading] = useState(false);
  const [oldResponse, setOldResponse] = useState([]);
  const [prNumberList, setPRNumberList] = useState([]);
  
  useEffect(() => {
    const rfqGetById = async () => {
      setapiLoading(true);
      try {
        // const apiResponse = await getRequest(`float-rfq/${responseId}/`);
        const apiResponse = RFQMaterialDetails1;
        if (apiResponse?.data?.success) {
          setPRNumberList(
            apiResponse.data.data.purchase_requisition_city_by_pr_number
          );
          const rfqDetailsData = apiResponse?.data?.data?.rfq_details[0];
          setResponse(apiResponse.data.data);
          const allDiameters = new Set();
          apiResponse.data.data.pr_city_wise_by_pr_number?.forEach(
            (cityObj) => {
              cityObj.city_wise_pr.forEach((city) => {
                city.site_wise_details.forEach((site) => {
                  site.material_wise_details.forEach((material) => {
                    material.diameter_wise?.forEach((dia) => {
                      allDiameters.add(parseInt(dia.diameter_name) + "MM");
                    });
                  });
                });
              });
            }
          );
          setDiameterList(
            Array.from(allDiameters).sort((a, b) => parseInt(a) - parseInt(b))
          );
        } else {
          ErrorNotificationMsg(t("error_in_rfq_detail"));
          setapiLoading(false);
        }
      } catch (error) {
        console.error("Error fetching RFQ details", error);
        setapiLoading(false);
      }
    };

    if (responseId) {
      rfqGetById();
    }
  }, [responseId]);

  useEffect(() => {
    if (siteName.length === 0) {
      getSiteName();
      // setPincodeList(uomList);
    }
  }, []);

  const updateTableData = (state) => {
    if (!Array.isArray(state) || !state[0]?.city_wise_pr) {
      return;
    }

    let rfqPresent = null;

    const uniqueMasterIds = new Set();

    state?.forEach((city) => {
      city.city_wise_pr?.forEach((cityDetail) => {
        cityDetail.site_wise_details?.forEach((site) => {
          site.material_wise_details?.forEach((material) => {
            if (material.purchase_requisition_master_id) {
              uniqueMasterIds.add(material.purchase_requisition_master_id);
            }
          });
        });
      });
    });

    const hasMultipleMasterIds = uniqueMasterIds.size > 1;

    const uniqueMasterIdsBySite = {};
    state?.forEach((city) => {
      city.city_wise_pr?.forEach((cityDetail) => {
        cityDetail.site_wise_details?.forEach((site) => {
          const uniqueMasterIds = new Set();
          site.material_wise_details?.forEach((material) => {
            if (material.purchase_requisition_master_id) {
              uniqueMasterIds.add(material.purchase_requisition_master_id);
            }
          });
          uniqueMasterIdsBySite[site.site_id] = Array.from(uniqueMasterIds);
        });
      });
    });

    const uniqueMasterIdsBySiteAndMaterial = {};
    state?.forEach((city) => {
      city.city_wise_pr?.forEach((cityDetail) => {
        cityDetail.site_wise_details?.forEach((site) => {
          const siteName = site.site_name;
          if (!uniqueMasterIdsBySiteAndMaterial[siteName]) {
            uniqueMasterIdsBySiteAndMaterial[siteName] = {};
          }
          site.material_wise_details?.forEach((material) => {
            const materialTypeName = material.material_type_name;
            if (!uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName]) {
              uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName] =
                new Set();
            }
            if (material.purchase_requisition_master_id) {
              uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName].add(
                material.purchase_requisition_master_id
              );
            }
          });
        });
      });
    });

    const tableData = [];
    const length =
      Array.isArray(state) && state[0]?.city_wise_pr
        ? state[0].city_wise_pr.length
        : 0;
    setCityLength(length);

    state.forEach((prObject, prIndex) => {
      prObject.city_wise_pr.forEach((city, cityIndex) => {
        const cityRowSpan = city.site_wise_details.length;
        let cityTotalQuantity = 0;
        let cityTotalQuantityInKg = 0;
        let cityTotal = 0;
        let cityTotalWithKG = 0;

        city.site_wise_details.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteTotalQuantityInKg = 0;
          let siteMaterialTotalAmount = 0;
          let siteMaterialTotalAmountWithKG = 0;
          const seenSubCategories = new Set();
          const groupedData = {};
          site.material_wise_details.forEach((material) => {
            const rfqId = material.purchase_requisition_material_id || null;

            const rfqActualId = material.rfq_material_id || null;

            rfqPresent = material.rfq_material_id;

            if (!groupedData[rfqId]) {
              groupedData[rfqId] = {
                rfq_material_id: rfqId,
                site_id: site.site_id,
                rfqActualId: rfqActualId,
                site_name: site.site_name,
                material_type_names: new Set([material.material_type_name]),
                material_type_sub_category: material.material_type_sub_category,
                pr_total_quantity: material.pr_total_quantity,
                pr_total_quantity_by_kg: material.pr_total_quantity_by_kg,
                estimated_material_unit_price:
                  material.estimated_material_unit_price,
                pr_total_amount: material.pr_total_amount,
                material_type_uom: material.material_type_uom,
                material_type_uom_name: hasMultipleMasterIds
                  ? material.material_type_uom_name
                  : material.preferred_unit_of_measurement,
                preferred_unit_of_measurement:
                  material.preferred_unit_of_measurement,
                preferred_unit_of_measurement_id:
                  material.preferred_unit_of_measurement_id,
                purchase_requisition_material_id:
                  material.purchase_requisition_material_id,
                diameter_wise_map: {},
              };
            } else {
              groupedData[rfqId].material_type_names.add(
                material.material_type_name
              );
              groupedData[rfqId].pr_total_quantity +=
                material.pr_total_quantity;
              groupedData[rfqId].pr_total_amount += material.pr_total_amount;
            }
          });

          const result = Object.values(groupedData).map((item) => ({
            ...item,
            material_type_names: Array.from(item.material_type_names).join(
              ", "
            ),
          }));

          const sortedMaterials = [...site.material_wise_details].sort((a, b) =>
            a.material_type_sub_category.localeCompare(b.material_type_sub_category)
          );
          const materialGroups = site.material_wise_details.reduce(
            (acc, material, index) => {
              if (material.purchase_requisition_master_id) {
                uniqueMasterIds.add(material.purchase_requisition_master_id);
              }
              const {
                material_type_name,
                material_type_uom_name,
                preferred_unit_of_measurement,
                pr_total_quantity,
                pr_total_quantity_by_kg,
                estimated_material_unit_price,
                pr_total_amount,
                purchase_requisition_master_id,
                actual_quantity,
                rfq_material_id,
                purchase_requisition_material_id,
                preferred_unit_of_measurement_id,
                material_type_uom,
                remark,
                vendors,
                material_type_sub_category,
              } = material;

              if (!acc[material_type_name]) {
                acc[material_type_name] = {
                  material_type_name,
                  preferred_unit_of_measurement,
                  material_type_uom_name,
                  total_quantity: 0,
                  actual_quantity: 0,
                  total_quantity_by_kg: 0,
                  total_amount: 0,
                  estimated_material_unit_price,
                  purchase_requisition_master_ids: new Set(),
                  rfq_material_id,
                  purchase_requisition_material_id,
                  preferred_unit_of_measurement_id,
                  material_type_uom,
                  remark,
                  vendors,
                  siteIndex,
                  cityIndex,
                  index,
                  material_type_sub_category,
                  diameter_wise_map: {},
                };
              }

              const currentSiteName = site.site_name;
              const currentMaterialTypeName = material_type_name;
              const uniqueMasterIdss =
                uniqueMasterIdsBySiteAndMaterial[currentSiteName]?.[
                  currentMaterialTypeName
                ] || [];

              let convertedQuantity = pr_total_quantity;
              if (
                material_type_uom_name !== preferred_unit_of_measurement &&
                uniqueMasterIdss.size > 1 &&
                rfq_material_id === null
              ) {
                if (
                  material_type_uom_name === "Bag" &&
                  preferred_unit_of_measurement === "KG"
                ) {
                  convertedQuantity = pr_total_quantity * 50;
                } else if (
                  material_type_uom_name === "Bag" &&
                  preferred_unit_of_measurement === "MT"
                ) {
                  convertedQuantity = (pr_total_quantity * 50) / 1000;
                } else if (
                  material_type_uom_name === "KG" &&
                  preferred_unit_of_measurement === "MT"
                ) {
                  convertedQuantity = pr_total_quantity / 1000; 
                } else if (
                  material_type_uom_name === "MT" &&
                  preferred_unit_of_measurement === "KG"
                ) {
                  convertedQuantity = pr_total_quantity * 1000; 
                }
              } else if (
                material_type_uom_name !== preferred_unit_of_measurement &&
                uniqueMasterIdss.size === 1 &&
                rfq_material_id === null
              ) {
                if (
                  material_type_uom_name === "Bag" &&
                  preferred_unit_of_measurement === "KG"
                ) {
                  convertedQuantity = pr_total_quantity;
                } else if (
                  material_type_uom_name === "Bag" &&
                  preferred_unit_of_measurement === "MT"
                ) {
                  convertedQuantity = pr_total_quantity;
                } else if (
                  material_type_uom_name === "KG" &&
                  preferred_unit_of_measurement === "MT"
                ) {
                  convertedQuantity = pr_total_quantity;
                } else if (
                  material_type_uom_name === "MT" &&
                  preferred_unit_of_measurement === "KG"
                ) {
                  convertedQuantity = pr_total_quantity;
                }
              } else {
                if (
                  material_type_uom_name === "Bag" &&
                  preferred_unit_of_measurement === "KG"
                ) {
                  convertedQuantity = pr_total_quantity;
                } else if (
                  material_type_uom_name === "Bag" &&
                  preferred_unit_of_measurement === "MT"
                ) {
                  convertedQuantity = pr_total_quantity;
                } else if (
                  material_type_uom_name === "KG" &&
                  preferred_unit_of_measurement === "MT"
                ) {
                  convertedQuantity = pr_total_quantity;
                } else if (
                  material_type_uom_name === "MT" &&
                  preferred_unit_of_measurement === "KG"
                ) {
                  convertedQuantity = pr_total_quantity;
                }
              }

              acc[material_type_name].total_quantity += convertedQuantity;
              acc[material_type_name].actual_quantity += convertedQuantity;
              acc[material_type_name].total_quantity_by_kg +=
                pr_total_quantity_by_kg;
              acc[material_type_name].total_amount += pr_total_amount;

              if (purchase_requisition_master_id) {
                acc[material_type_name].purchase_requisition_master_ids.add(
                  purchase_requisition_master_id
                );
              }

              (material.diameter_wise || []).forEach((dia) => {
                const key = dia.diameter_id;
                if (!acc[material_type_name].diameter_wise_map[key]) {
                  acc[material_type_name].diameter_wise_map[key] = {
                    ...dia,
                    quantity: 0,
                  };
                }
                acc[material_type_name].diameter_wise_map[key].quantity +=
                  dia.quantity;
              });

              return acc;
            },
            {}
          );

          let groupedMaterials = Object.values(materialGroups).map(
            (material) => {
              let unitMeasurement = "MT";
              let unitMeasurementId = 1;

              if (
                material.total_quantity_by_kg / 1000 ===
                material.total_quantity
              ) {
                unitMeasurement = material.preferred_unit_of_measurement;
                unitMeasurementId = material.preferred_unit_of_measurement_id;
              } else if (
                material.total_quantity_by_kg / 50 ===
                material.total_quantity
              ) {
                unitMeasurement = material.material_type_uom_name;
                unitMeasurementId = material.material_type_uom;
              }
              if (
                Array.from(material.purchase_requisition_master_ids).length >
                  1 &&
                material.rfq_material_id === null
              ) {
                material.material_type_uom = unitMeasurementId;
                material.material_type_uom_name = unitMeasurement;
                return {
                  ...material,
                  purchase_requisition_master_ids: Array.from(
                    material.purchase_requisition_master_ids
                  ),
                };
              } else {
                return {
                  ...material,
                  purchase_requisition_master_ids: Array.from(
                    material.purchase_requisition_master_ids
                  ),
                };
              }
            }
          );
          groupedMaterials = Object.values(materialGroups);

          groupedMaterials.forEach((material) => {
            const {
              material_type_name,
              preferred_unit_of_measurement,
              total_quantity,
              total_amount,
              total_quantity_by_kg,
              actual_quantity,
            } = material;

            siteTotalQuantity += total_quantity;
            siteMaterialTotalAmount += material.total_amount;
            siteTotalQuantityInKg += total_quantity_by_kg;

            if (material.material_type_sub_category === "RMC") {
              siteMaterialTotalAmountWithKG +=
                material.total_quantity *
                material.estimated_material_unit_price;
            } else {
              siteMaterialTotalAmountWithKG +=
                material.total_quantity_by_kg *
                material.estimated_material_unit_price;
            }
          });

          site.site_total_quantity = siteTotalQuantity;
          cityTotalQuantity += siteTotalQuantity;
          cityTotalQuantityInKg += siteTotalQuantityInKg;
          cityTotal += siteMaterialTotalAmount;
          cityTotalWithKG += siteMaterialTotalAmountWithKG;

          

          tableData.push({
            key: `${prIndex}-${cityIndex}-${siteIndex}`,
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : "",
            cityName1: city.city_name,

            cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
            siteName: site.site_name,
            siteName1: site.site_name,
            siteData: result,
            siteLocations: groupedMaterials.map((material, ind) => {
              const diameter_wise = Object.values(
                material.diameter_wise_map || {}
              );
              const subCategory = material.material_type_sub_category;
              const showSubCategory = !seenSubCategories.has(subCategory);
              seenSubCategories.add(subCategory);
              return {
                vendors: material?.vendors,
                cityName: city.city_name,
                cityIndex: material.cityIndex,
                siteIndex: material.cityIndex,
                siteId: site.site_name,
                matInd: ind,
                materialName: material.material_type_name,
                quantity: material.total_quantity,
                actual_quantity: material.actual_quantity,
                quantity_by_kg: material.total_quantity_by_kg.toLocaleString(
                  "en-IN",
                  {
                    maximumFractionDigits: 0,
                  }
                ),
                remark: material.remark,
                uom: material.preferred_unit_of_measurement,
                uom_pref: material.preferred_unit_of_measurement_id,
                subCategory: showSubCategory ? subCategory : "",
                estimatedPrice: material.estimated_material_unit_price,
                materialTotal: material.total_amount,
                unit_measurement: material.material_type_uom,
                unit_measurement_id: material.material_type_uom,
                unit_measurement_name: material.material_type_uom_name,
                purchase_master_ids: [
                  ...material.purchase_requisition_master_ids,
                ],
                purchase_requisition_material_id:
                  material.purchase_requisition_material_id,
                rfq_material_idd: material.rfq_material_id,
                diameter_wise,
              };
            }),
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
                className="site-subtotal"
              />
            ),
          });

          tableData.push({
            key: `${prIndex}-${cityIndex}-${siteIndex}-SiteSubTotal`,
            siteName: "Site Sub-Total",
            siteLocations: [
              {
                totalQuantity: siteMaterialTotalAmountWithKG,
                materialName: "",
                quantity: "",
                quantity_by_kg: "",
                subCategory: "",
                siteIndex,
                cityId: city.city_id,
                siteId: site.site_id,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
                className="site-subtotal"
              />
            ),
            siteTotalQuantity: (
              <Input
                disabled
                value={
                  siteTotalQuantity?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  }) || 0
                }
                className="site-total-quantity"
                readOnly
              />
            ),
          });

          if (length > 1 && siteIndex === city.site_wise_details.length - 1) {
            tableData.push({
              key: `${prIndex}-${cityIndex}-${siteIndex}-CityTotal`,
              siteName: "City Total",
              siteLocations: [
                {
                  materialName: "",
                  cityTotal: cityTotalWithKG,
                  quantity: "",
                  quantity_by_kg: "",
                  subCategory: "",
                  siteIndex,
                  cityId: city.city_id,
                  siteId: site.site_id,
                },
              ],
              totalAmount: cityTotal,
              cityTotalQuantity: (
                <Input
                  disabled
                  value={cityTotalQuantity || 0}
                  className="city-total-quantity"
                  readOnly
                />
              ),
            });
          }
        });

        city.city_total_quantity = cityTotal;
      });
    });

    setTableData(tableData);
  };

  useEffect(() => {
    if (response && response.pr_city_wise_by_pr_number) {
      updateTableData(response?.pr_city_wise_by_pr_number);
      setOldResponse(response?.pr_city_wise_by_pr_number);
    }

    if (
      response &&
      Array.isArray(response?.rfq_material_details) &&
      response?.rfq_material_details.length === 0
    ) {
      setRfqMaterialDetailsID(false);
    } else if (response) {
      setRfqMaterialDetailsID(true);
    }
    if (response) {
      setapiLoading(false);
    }
  }, [response]);

  const getSiteName = async () => {
    try {
      let apiResponse = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/`
      );
      if (apiResponse.data.data) {
        setSiteName(apiResponse.data.data);
        const updatedState = { ...state };
        updatedState.purchase_requisition_details.forEach((detail) => {
          detail.site_wise.forEach((site, index) => {
            site.site_name = apiResponse.data.data[index]
              ? apiResponse.data.data[index].site.id
              : null;
          });
        });
        setState(updatedState);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
    } catch (error) {
      //setLoading(false);
    }
  };



  const wbsBudget = [
    {
      title: "SR.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      fixed: "left",
      width: 200,
      render: (text) => <div className="lblvalue">{text}</div>,
    },
    {
      title: "Available Budget",
      dataIndex: "siteLocations",
      align: "right",
      width: 200,
      render: (siteLocations, record) => {
        let totalAvail = 10000000;
        if (record.siteName !== "City Total" && record.siteName !== "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                key={1}
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100px",
                }}
              >
                ₹{" "}
                {totalAvail?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                })}
              </div>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Estimated PR Value",
      dataIndex: "siteLocations",
      align: "right",
      render: (siteLocations, record) => {
        if (record.siteName === "City Total" || record.siteName === "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "110px",
                }}
              >
                ₹{" "}
                {siteLocations[0].cityTotal?.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                })}
              </div>
            </div>
          );
        } else {
          let total = siteLocations.reduce(
            (acc, site) => acc + site.materialTotal,
            0
          );

          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <div
                key={1}
                className="lblvalue"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "110px",
                }}
              >
                ₹{" "}
                {total
                  ? total?.toLocaleString("en-IN", { maximumFractionDigits: 0 })
                  : 0}
              </div>
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    wbsBudget.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    });
  }

  const panelHeader = (
    <table style={{ width: "100%", tableLayout: "fixed" }}>
      <thead>
        <tr>
          {wbsBudget.map((col, index) => (
            <th
              key={index}
              style={{
                width: col.width || "auto",
                padding: "5px 10px",
                fontWeight: "normal",
              }}
            >
              {col.title}
            </th>
          ))}
        </tr>
      </thead>
    </table>
  );

  const diameterColumns = diameterList.map((dia) => ({
    title: dia,
    dataIndex: "siteLocations",
    width: 80,
    align: "center",
    render: (siteLocations, record) => {
      if (
        record.siteName === "Site Sub-Total" ||
        record.siteName === "City Total"
      ) {
        return null;
      }
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
          {siteLocations.map((site, index) => {
            const found = site.diameter_wise?.find(
              (d) => parseInt(d.diameter_name) + "MM" === dia
            );
            return (
              <div key={index} className="lblvalue">
                {found ? found.quantity : "-"}
              </div>
            );
          })}
        </div>
      );
    },
  }));

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return {
            children: <div className="subtotal">Sub Total</div>,
          };
        } else if (record.siteName === "City Total") {
          return {
            children: <div className="citytotal">{record.siteName}</div>,
          };
        } else {
          return <div>{record.siteName}</div>;
        }
      },
    },
        {
      title: "Sub category",
      dataIndex: "siteLocations",
      width: 140,
      render: (siteLocations) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
          {siteLocations.map((site, index) => (
            <div key={index} className="lblvalue">
              {site.subCategory || ""}
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "Grade & Quality",
      dataIndex: "siteLocations",
      width: 240,
      render: (siteLocations) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "22px", width:'220px' }}>
          {siteLocations.map((site, index) => (
            <div key={index} className="lblvalue">
              {site.materialName}
            </div>
          ))}
        </div>
      ),
    },
    ...diameterColumns,
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material
              generally in this unit of measurement
            </span>
          }
        >
          UoM.
        </Tooltip>
      ),
      width: 120,
      dataIndex: "siteLocations",
      render: (siteLocations) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
          {siteLocations.map((site, index) => (
            <div key={index} className="lblvalue">
              {site.unit_measurement_name || site.unit_measurement_name || ""}
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "Qty. In Kg",
      dataIndex: "siteLocations",
      width: 100,
      align: "right",
      render: (siteLocations, record) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
            }}
          >
            {siteLocations.map((site, index) => {
              return (
                <div
                  key={index}
                  className="lblvalue"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {site.quantity_by_kg == 0 && site.subCategory === "RMC"
                    ? "-"
                    : site.quantity_by_kg?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      }) || ""}
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      title: "Est. Amount",
      dataIndex: "siteLocations",
      align: "right",
      width: "130px",
      render: (siteLocations, record) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
              alignItems: "flex-end",
            }}
          >
            {siteLocations.map((site, index) => {
              let total = 0;

              if (site?.subCategory === "RMC") {
                total =
                  site?.subCategory === "RMC"
                    ? Number(site?.quantity) * site?.estimatedPrice
                    : site?.materialTotal;
              } else {
                total =
                  Number(site?.quantity_by_kg.replace(/,/g, "")) *
                  site?.estimatedPrice;
              }

              if (site.materialName !== "") {
                return (
                  <div
                    key={index}
                    className="lblvalue "
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    {total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    }) || ""}
                  </div>
                );
              } else if (record.siteName === "Site Sub-Total") {
                return (
                  <div
                    key={index}
                    className="lblvalue subtotal"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    <span>
                      {site?.totalQuantity.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}
                    </span>
                  </div>
                );
              } else if (record.siteName === "City Total") {
                return (
                  <div
                    key={index}
                    className="lblvalue citytotal"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    <span>
                      {site.cityTotal.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}
                    </span>
                  </div>
                );
              } else {
                return (
                  <div
                    key={index}
                    className="lblvalue"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹{" "}
                    {site?.totalQuantity?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    }) || ""}
                  </div>
                );
              }
            })}
          </div>
        );
      },
    },
    {
      title: (
        <Tooltip color="#094E8F" placement="top">
          <span style={{ textTransform: "none" }}>{t("bidders")}</span>
        </Tooltip>
      ),
      width: 340,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total"
        ) {
          return "";
        }

        if (
          siteLocations &&
          siteLocations.length > 0 &&
          siteLocations.materialName !== ""
        ) {
          return (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              {siteLocations.map((site, index) => {
                const selectedVendors = site?.vendors?.filter(
                  (vendor) => vendor.is_selected_vendor
                );
                return (
                  <div
                    key={index}
                    style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
                  >
                    {selectedVendors?.map((vendor) => (
                      <Tag key={vendor.id}>{vendor.name}</Tag>
                    ))}
                  </div>
                );
              })}
            </div>
          );
        }

        return null;
      },
    },
    {
      title: "Remark",
      dataIndex: "siteLocations",
      align: "left",
       className: "no-transform-remarks",
      render: (siteLocations, record) => {
        if (
          record.siteName !== "City Total" ||
          record.siteName !== "Site Sub-Total"
        ) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "22px",
                marginRight: "40px",
              }}
            >
              {siteLocations.map((site, index) => {
                return (
                  <div key={index} className="lblvalue">
                    {site.remark || ""}
                  </div>
                );
              })}
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 110,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  useEffect(() => {}, [tableData]);
  const getVendorIds = (siteIndex) => {
    const vendors = siteIndex?.vendors || [];
    if (Array.isArray(siteIndex?.vendor) && siteIndex.vendor.length > 0) {
      return siteIndex.vendor;
    }

    const hasSelectedVendor = vendors.some((v) => v.is_selected_vendor);

    if (hasSelectedVendor) {
      return vendors.filter((v) => v.is_selected_vendor).map((v) => v.id);
    } else {
      return vendors.map((v) => v.id);
    }
  };
  const createPayload = (tableData) => {
    const payload = {
      rfq_master: masterId,
      rfq_site_details: [],
    };

    const siteGroupedData = {};

    tableData.forEach((site) => {
      if (!site.siteLocations || site.siteName === "Site Sub-Total") return;

      if (site.siteData && Array.isArray(site.siteData)) {
        site.siteData.forEach((location) => {
          const siteIndex = site.siteLocations.find(
            (siteLocation) =>
              siteLocation.siteId === location.site_name &&
              siteLocation.materialName === location.material_type_names
          );

          if (siteIndex) {
            const siteName = location.site_id;

            if (!siteGroupedData[siteName]) {
              siteGroupedData[siteName] = {
                purchase_requisition_site_name: siteName,
                rfq_material_details: [],
              };
            }
            let material_total_quantity;

            if (siteIndex.purchase_master_ids.length > 1) {
              if (siteIndex.uom === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "MT") {
                material_total_quantity =
                  location.pr_total_quantity_by_kg / 1000;
              } else if (siteIndex.unit_measurement_name === "Bag") {
                material_total_quantity = location.pr_total_quantity_by_kg / 50;
              } else if (siteIndex.unit_measurement_name === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else {
                material_total_quantity = location.pr_total_quantity;
              }
            } else {
              if (siteIndex.uom === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "MT") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "Bag") {
                material_total_quantity = location.pr_total_quantity;
              }
              else {
                material_total_quantity = location.pr_total_quantity;
              }
            }

            siteGroupedData[siteName].rfq_material_details.push({
              id: location.rfqActualId || null,
              material_total_quantity: material_total_quantity,
              material_total_quantity_by_kg:
                location.pr_total_quantity_by_kg || 0,
              amount:
                location.material_type_uom_name === "Cubic Meter"
                  ? location.pr_total_quantity *
                    location.estimated_material_unit_price
                  : location.pr_total_quantity_by_kg *
                      location.estimated_material_unit_price || 0,
              purchase_requisition_material:
                location.purchase_requisition_material_id,
              unit_of_measurement:
                siteIndex.purchase_master_ids.length > 1
                  ? location.material_type_uom_name === "Cubic Meter"
                    ? 4
                    : siteIndex.unit_measurement
                  : siteIndex.unit_measurement,
              vendor: getVendorIds(siteIndex),
            });
          } else {
            console.warn(
              "No matching siteIndex found for location:",
              location.site_name
            );
          }
        });
      } else {
        console.warn("No siteData found for site:", site);
      }
    });

    payload.rfq_site_details = Object.values(siteGroupedData);

    return payload;
  };

  const createPayload2 = (tableData) => {
    const payload = {
      rfq_master: masterId,
      rfq_site_details: [],
    };

    const siteGroupedData = {};

    tableData.forEach((site) => {
      if (!site.siteLocations || site.siteName === "Site Sub-Total") return;

      if (site.siteData && Array.isArray(site.siteData)) {
        site.siteData.forEach((location) => {
          const siteIndex = site.siteLocations.find(
            (siteLocation) =>
              siteLocation.siteId === location.site_name &&
              siteLocation.materialName === location.material_type_names
          );

          if (siteIndex) {
            const siteName = location.site_id;

            if (!siteGroupedData[siteName]) {
              siteGroupedData[siteName] = {
                purchase_requisition_site_name: siteName,
                rfq_material_details: [],
              };
            }
            let material_total_quantity;

            if (siteIndex.purchase_master_ids.length > 1) {
              if (siteIndex.uom === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "MT") {
                material_total_quantity =
                  location.pr_total_quantity_by_kg / 1000;
              } else if (siteIndex.unit_measurement_name === "Bag") {
                material_total_quantity = location.pr_total_quantity_by_kg / 50;
              }
              else {
                material_total_quantity = location.pr_total_quantity;
              }
            } else {
              if (siteIndex.uom === "Cubic Meter") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "MT") {
                material_total_quantity = location.pr_total_quantity;
              } else if (siteIndex.unit_measurement_name === "Bag") {
                material_total_quantity = location.pr_total_quantity;
              }
              else {
                material_total_quantity = location.pr_total_quantity;
              }
            }

            siteGroupedData[siteName].rfq_material_details.push({
              id: location.rfqActualId || null,
              material_total_quantity: material_total_quantity,
              material_total_quantity_by_kg:
                location.pr_total_quantity_by_kg || 0,
              amount:
                location.material_type_uom_name === "Cubic Meter"
                  ? location.estimated_material_unit_price *
                    location.pr_total_quantity
                  : location.pr_total_amount || 0,
              purchase_requisition_material:
                location.purchase_requisition_material_id,
              unit_of_measurement:
                siteIndex.purchase_master_ids.length > 1
                  ? location.material_type_uom_name === "Cubic Meter"
                    ? 4
                    : siteIndex.unit_measurement
                  : siteIndex.unit_measurement,
            });
          } else {
            console.warn(
              "No matching siteIndex found for location:",
              location.site_name
            );
          }
        });
      } else {
        console.warn("No siteData found for site:", site);
      }
    });

    payload.rfq_site_details = Object.values(siteGroupedData);

    return payload;
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const hasEmptyVendor = tableData.some((item) =>
        item.siteData?.some(
          (material) =>
            Array.isArray(material.vendor) && material.vendor.length === 0
        )
      );

      if (hasEmptyVendor) {
        ErrorNotificationMsg("Select At Least One Vendor");
        setBtnLoading(false);
        return;
      }
      const payload = createPayload(tableData);
      const payload2 = createPayload2(tableData);

      let response;
      if (rfqMaterialDetailsID === false) {
        response = await postRequest(`rfq-material-details/`, payload2);
      } else {
        response = await patchRequest(
          `rfq-material-details/${masterId}/`,
          payload
        );

        if (response.data.message) {
          SuccessNotificationMsg(response.data.message);
          navigate(`/request-for-quotation/history`);
        }
      }

      if (response.data.success && rfqMaterialDetailsID === false) {
        setBtnLoading(true);
        const updateTableData = (state) => {
          if (!Array.isArray(state)) {
            return;
          }
          let rfqPresent = null;
          const uniqueMasterIds = new Set();
          state?.forEach((city) => {
            city.city_wise_pr?.forEach((cityDetail) => {
              cityDetail.site_wise_details?.forEach((site) => {
                site.material_wise_details?.forEach((material) => {
                  if (material.purchase_requisition_master_id) {
                    uniqueMasterIds.add(
                      material.purchase_requisition_master_id
                    );
                  }
                });
              });
            });
          });

          const hasMultipleMasterIds = uniqueMasterIds.size > 1;

          const tableData = [];
          const length = state[0].city_wise_pr.length;
          setCityLength(length);

          state.forEach((prObject, prIndex) => {
            prObject.city_wise_pr.forEach((city, cityIndex) => {
              const cityRowSpan = city.site_wise_details.length;
              let cityTotalQuantity = 0;
              let cityTotalQuantityInKg = 0;
              let cityTotal = 0;

              city.site_wise_details.forEach((site, siteIndex) => {
                let siteTotalQuantity = 0;
                let siteTotalQuantityInKg = 0;
                let siteMaterialTotalAmount = 0;

                let siteMaterialTotalAmountWithKG = 0;

                const groupedData = {};
                site.material_wise_details.forEach((material) => {
                  const rfqId =
                    material.purchase_requisition_material_id || null;

                  const rfqActualId = material.rfq_material_id || null;

                  rfqPresent = material.rfq_material_id;

                  if (!groupedData[rfqId]) {
                    groupedData[rfqId] = {
                      rfq_material_id: rfqId,
                      site_id: site.site_id,
                      rfqActualId: rfqActualId,
                      site_name: site.site_name,
                      material_type_names: new Set([
                        material.material_type_name,
                      ]),
                      material_type_sub_category:
                        material.material_type_sub_category,
                      pr_total_quantity: material.pr_total_quantity,
                      pr_total_quantity_by_kg: material.pr_total_quantity_by_kg,
                      estimated_material_unit_price:
                        material.estimated_material_unit_price,
                      pr_total_amount: material.pr_total_amount,
                      material_type_uom: material.material_type_uom,
                      material_type_uom_name: hasMultipleMasterIds
                        ? material.material_type_uom_name
                        : material.preferred_unit_of_measurement,
                      preferred_unit_of_measurement:
                        material.preferred_unit_of_measurement,
                      preferred_unit_of_measurement_id:
                        material.preferred_unit_of_measurement_id,
                      purchase_requisition_material_id:
                        material.purchase_requisition_material_id,
                      diameter_wise_map: {},
                    };
                  } else {
                    groupedData[rfqId].material_type_names.add(
                      material.material_type_name
                    );
                    groupedData[rfqId].pr_total_quantity +=
                      material.pr_total_quantity;
                    groupedData[rfqId].pr_total_amount +=
                      material.pr_total_amount;
                  }
                });
                const result = Object.values(groupedData).map((item) => ({
                  ...item,
                  material_type_names: Array.from(
                    item.material_type_names
                  ).join(", "),
                }));
                const materialGroups = site.material_wise_details.reduce(
                  (acc, material, index) => {
                    if (material.purchase_requisition_master_id) {
                      uniqueMasterIds.add(
                        material.purchase_requisition_master_id
                      );
                    }

                    const {
                      material_type_name,
                      material_type_uom_name,
                      preferred_unit_of_measurement,
                      pr_total_quantity,
                      pr_total_quantity_by_kg,
                      estimated_material_unit_price,
                      pr_total_amount,
                      purchase_requisition_master_id,
                      actual_quantity,
                      rfq_material_id,
                      purchase_requisition_material_id,
                      preferred_unit_of_measurement_id,
                      material_type_uom,
                      remark,
                      vendors,
                    } = material;

                    if (!acc[material_type_name]) {
                      acc[material_type_name] = {
                        material_type_name,
                        preferred_unit_of_measurement,
                        material_type_uom_name,
                        total_quantity: 0,
                        actual_quantity: 0,
                        total_quantity_by_kg: 0,
                        total_amount: 0,
                        estimated_material_unit_price,
                        purchase_requisition_master_ids: new Set(),
                        rfq_material_id,
                        purchase_requisition_material_id,
                        preferred_unit_of_measurement_id,
                        material_type_uom,
                        remark,
                        vendors,
                        siteIndex,
                        cityIndex,
                        index,
                        diameter_wise_map: {},
                      };
                    }

                    let convertedQuantity = pr_total_quantity;
                    if (
                      material_type_uom_name !==
                        preferred_unit_of_measurement &&
                      hasMultipleMasterIds &&
                      rfq_material_id === null
                    ) {
                      if (
                        material_type_uom_name === "Bag" &&
                        preferred_unit_of_measurement === "KG"
                      ) {
                        convertedQuantity = pr_total_quantity * 50;
                      } else if (
                        material_type_uom_name === "Bag" &&
                        preferred_unit_of_measurement === "MT"
                      ) {
                        convertedQuantity = (pr_total_quantity * 50) / 1000;
                      } else if (
                        material_type_uom_name === "KG" &&
                        preferred_unit_of_measurement === "MT"
                      ) {
                        convertedQuantity = pr_total_quantity / 1000;
                      } else if (
                        material_type_uom_name === "MT" &&
                        preferred_unit_of_measurement === "KG"
                      ) {
                        convertedQuantity = pr_total_quantity * 1000;
                      }
                    } else {
                      if (
                        material_type_uom_name === "Bag" &&
                        preferred_unit_of_measurement === "KG"
                      ) {
                        convertedQuantity = pr_total_quantity;
                      } else if (
                        material_type_uom_name === "Bag" &&
                        preferred_unit_of_measurement === "MT"
                      ) {
                        convertedQuantity = pr_total_quantity;
                      } else if (
                        material_type_uom_name === "KG" &&
                        preferred_unit_of_measurement === "MT"
                      ) {
                        convertedQuantity = pr_total_quantity;
                      } else if (
                        material_type_uom_name === "MT" &&
                        preferred_unit_of_measurement === "KG"
                      ) {
                        convertedQuantity = pr_total_quantity;
                      }
                    }

                    acc[material_type_name].total_quantity += convertedQuantity;
                    acc[material_type_name].actual_quantity +=
                      convertedQuantity;
                    acc[material_type_name].total_quantity_by_kg +=
                      pr_total_quantity_by_kg;
                    acc[material_type_name].total_amount += pr_total_amount;

                    if (purchase_requisition_master_id) {
                      acc[
                        material_type_name
                      ].purchase_requisition_master_ids.add(
                        purchase_requisition_master_id
                      );
                    }

                    (material.diameter_wise || []).forEach((dia) => {
                      const key = dia.diameter_id;
                      if (!acc[material_type_name].diameter_wise_map[key]) {
                        acc[material_type_name].diameter_wise_map[key] = {
                          ...dia,
                          quantity: 0,
                        };
                      }
                      acc[material_type_name].diameter_wise_map[key].quantity +=
                        dia.quantity;
                    });

                    return acc;
                  },
                  {}
                );
                let groupedMaterials = Object.values(materialGroups).map(
                  (material) => {
                    let unitMeasurement = "MT";
                    let unitMeasurementId = 1;

                    if (
                      material.total_quantity_by_kg / 1000 ===
                      material.total_quantity
                    ) {
                      unitMeasurement = material.preferred_unit_of_measurement;
                      unitMeasurementId =
                        material.preferred_unit_of_measurement_id;
                    } else if (
                      material.total_quantity_by_kg / 50 ===
                      material.total_quantity
                    ) {
                      unitMeasurement = material.material_type_uom_name;
                      unitMeasurementId = material.material_type_uom;
                    }
                    if (
                      Array.from(material.purchase_requisition_master_ids)
                        .length > 1 &&
                      material.rfq_material_id === null
                    ) {
                      material.material_type_uom = unitMeasurementId;
                      material.material_type_uom_name = unitMeasurement;
                      return {
                        ...material,
                        purchase_requisition_master_ids: Array.from(
                          material.purchase_requisition_master_ids
                        ),
                      };
                    } else {
                      return {
                        ...material,
                        purchase_requisition_master_ids: Array.from(
                          material.purchase_requisition_master_ids
                        ),
                      };
                    }
                  }
                );
                groupedMaterials = Object.values(materialGroups);
                groupedMaterials.forEach((material) => {
                  const {
                    material_type_name,
                    preferred_unit_of_measurement,
                    total_quantity,
                    total_quantity_by_kg,
                  } = material;

                  siteTotalQuantity += total_quantity;
                  siteMaterialTotalAmount += material.total_amount;
                  siteTotalQuantityInKg += total_quantity_by_kg;
                  siteMaterialTotalAmountWithKG +=
                    total_quantity_by_kg * total_quantity;
                });

                site.site_total_quantity = siteTotalQuantity;
                cityTotalQuantity += siteTotalQuantity;
                cityTotalQuantityInKg += siteTotalQuantityInKg;
                cityTotal += siteMaterialTotalAmount;

                tableData.push({
                  key: `${prIndex}-${cityIndex}-${siteIndex}`,
                  srNo:
                    length > 1
                      ? siteIndex === 0
                        ? cityIndex + 1
                        : null
                      : siteIndex + 1,
                  cityName: siteIndex === 0 ? city.city_name : "",
                  cityName1: city.city_name,

                  cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
                  siteName: site.site_name,
                  siteName1: site.site_name,
                  siteData: result,
                  siteLocations: groupedMaterials.map((material, ind) => {
                    const diameter_wise = Object.values(
                      material.diameter_wise_map || {}
                    );
                    return {
                      vendors: material?.vendors,
                      cityName: city.city_name,
                      cityIndex: material.cityIndex,
                      siteIndex: material.cityIndex,
                      siteId: site.site_name,
                      matInd: ind,
                      materialName: material.material_type_name,
                      quantity: material.total_quantity,
                      actual_quantity: material.actual_quantity,
                      quantity_by_kg:
                        material.total_quantity_by_kg.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        }),
                      remark: material.remark,
                      uom: material.preferred_unit_of_measurement,
                      uom_pref: material.preferred_unit_of_measurement_id,
                      subCategory: material.material_type_sub_category,
                      estimatedPrice: material.estimated_material_unit_price,
                      materialTotal: material.total_amount,
                      unit_measurement: material.material_type_uom,
                      unit_measurement_id: material.material_type_uom,
                      unit_measurement_name: material.material_type_uom_name,
                      purchase_master_ids: [
                        ...material.purchase_requisition_master_ids,
                      ],
                      purchase_requisition_material_id:
                        material.purchase_requisition_material_id,
                      rfq_material_idd: material.rfq_material_id,
                      diameter_wise,
                    };
                  }),
                  totalAmount: (
                    <Input
                      disabled
                      value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
                      className="site-subtotal"
                    />
                  ),
                });

                tableData.push({
                  key: `${prIndex}-${cityIndex}-${siteIndex}-SiteSubTotal`,
                  siteName: "Site Sub-Total",
                  siteLocations: [
                    {
                      totalQuantity: siteMaterialTotalAmount,
                      materialName: "",
                      quantity: "",
                      quantity_by_kg: "",
                      subCategory: "",
                      siteIndex,
                      cityId: city.city_id,
                      siteId: site.site_id,
                    },
                  ],
                  totalAmount: (
                    <Input
                      disabled
                      value={`\u20B9 ${siteMaterialTotalAmount || 0}`}
                      className="site-subtotal"
                    />
                  ),
                  siteTotalQuantity: (
                    <Input
                      disabled
                      value={
                        siteTotalQuantity?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        }) || 0
                      }
                      className="site-total-quantity"
                      readOnly
                    />
                  ),
                });

                if (
                  length > 1 &&
                  siteIndex === city.site_wise_details.length - 1
                ) {
                  tableData.push({
                    key: `${prIndex}-${cityIndex}-${siteIndex}-CityTotal`,
                    siteName: "City Total",
                    siteLocations: [
                      {
                        materialName: "",
                        cityTotal: cityTotal,
                        quantity: "",
                        quantity_by_kg: "",
                        subCategory: "",
                        siteIndex,
                        cityId: city.city_id,
                        siteId: site.site_id,
                      },
                    ],
                    totalAmount: cityTotal,
                    cityTotalQuantity: (
                      <Input
                        disabled
                        value={cityTotalQuantity || 0}
                        className="city-total-quantity"
                        readOnly
                      />
                    ),
                  });
                }
              });

              city.city_total_quantity = cityTotal;
            });
          });

          return tableData;
        };
        const createPayload = (tableData, oldTableData) => {
          const payload = {
            rfq_master: masterId,
            rfq_site_details: [],
          };

          const siteGroupedData = {};

          tableData.forEach((site) => {
            if (!site.siteLocations || site.siteName === "Site Sub-Total")
              return;

            if (site.siteData && Array.isArray(site.siteData)) {
              site.siteData.forEach((location) => {
                const rfqID = tableData
                  .flatMap((item) => item.siteLocations)
                  .find(
                    (siteLocation) =>
                      siteLocation.siteId === location.site_name &&
                      siteLocation.materialName === location.material_type_names
                  )?.rfq_material_idd;

                const siteIndex = site.siteLocations.find(
                  (siteLocation) =>
                    siteLocation.siteId === location.site_name &&
                    siteLocation.materialName === location.material_type_names
                );

                const siteVendors = oldTableData
                  .flatMap((item) => item.siteLocations)
                  .find(
                    (siteLocation) =>
                      siteLocation.siteId === location.site_name &&
                      siteLocation.materialName === location.material_type_names
                  )?.vendor;

                if (siteIndex) {
                  const siteName = location.site_id;

                  if (!siteGroupedData[siteName]) {
                    siteGroupedData[siteName] = {
                      purchase_requisition_site_name: siteName,
                      rfq_material_details: [],
                    };
                  }
                  let material_total_quantity;

                  if (siteIndex.purchase_master_ids.length > 1) {
                    if (siteIndex.uom === "Cubic Meter") {
                      material_total_quantity = location.pr_total_quantity;
                    } else if (siteIndex.unit_measurement_name === "MT") {
                      material_total_quantity =
                        location.pr_total_quantity_by_kg / 1000;
                    } else if (siteIndex.unit_measurement_name === "Bag") {
                      material_total_quantity =
                        location.pr_total_quantity_by_kg / 50;
                    }
                    else {
                      material_total_quantity = location.pr_total_quantity;
                    }
                  } else {
                    if (siteIndex.uom === "Cubic Meter") {
                      material_total_quantity = location.pr_total_quantity;
                    } else if (siteIndex.unit_measurement_name === "MT") {
                      material_total_quantity = location.pr_total_quantity;
                    } else if (siteIndex.unit_measurement_name === "Bag") {
                      material_total_quantity = location.pr_total_quantity;
                    }
                    else {
                      material_total_quantity = location.pr_total_quantity;
                    }
                  }

                  siteGroupedData[siteName].rfq_material_details.push({
                    id: location.rfqActualId || null,
                    material_total_quantity: material_total_quantity,
                    material_total_quantity_by_kg:
                      location.pr_total_quantity_by_kg || 0,
                    amount:
                      location.material_type_uom_name === "Cubic Meter"
                        ? location.estimated_material_unit_price *
                          location.pr_total_quantity
                        : location.pr_total_amount || 0,
                    purchase_requisition_material:
                      location.purchase_requisition_material_id,
                    unit_of_measurement:
                      siteIndex.purchase_master_ids.length > 1
                        ? location.material_type_uom_name === "Cubic Meter"
                          ? 4
                          : siteIndex.unit_measurement
                        : siteIndex.unit_measurement,
                    vendor:
                      siteVendors !== undefined
                        ? siteVendors
                        : siteIndex?.vendors.map((i) => i.id) || [],
                  });
                } else {
                  console.warn(
                    "No matching siteIndex found for location:",
                    location.site_name
                  );
                }
              });
            } else {
              console.warn("No siteData found for site:", site);
            }
          });

          payload.rfq_site_details = Object.values(siteGroupedData);

          return payload;
        };
        const updateAndCallAPI = async () => {
          const res = updateTableData(
            response?.data?.data?.pr_city_wise_by_pr_number
          );

          const newPayload = createPayload(res, tableData);
          try {
            response = await patchRequest(
              `rfq-material-details/${masterId}/`,
              newPayload
            );

            if (response.data.message) {
              navigate(`/request-for-quotation/history`);
              SuccessNotificationMsg(response.data.message);

              setBtnLoading(false);
            } else {
              ErrorNotificationMsg(response.data.message);
              setBtnLoading(false);
            }
          } catch (error) {
            console.error("Error calling API:", error);
            setBtnLoading(false);
          }
        };

        updateAndCallAPI();
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <section className="grid-sec mt-5">
      <div className="PR-body tbl-collapse" style={{padding:'0'}}>
        <Spin spinning={apiLoading}>
          {
            <>
              {response?.pr_city_wise_by_pr_number?.map((prObject, prIndex) => {
                return (
                  <>
                    <Collapse
                      key={prIndex.toString()}
                      defaultActiveKey={["0"]}
                      className="scroll5"
                    >
                      <Panel header={theadPR} key={prIndex}>
                        <Table
                          columns={columns}
                          dataSource={tableData.filter((row) =>
                            row.key.startsWith(`${prIndex}`)
                          )}
                        
                          pagination={false}
                          rowKey="key"
                        />
                      </Panel>
                    </Collapse>
                  </>
                );
              })}
            </>
          }
        </Spin>
      </div>
    </section>
  );
};

ViewRFQSteel.propTypes = {
  RFQMaterialDetails1: PropTypes.object.isRequired,
};

export default ViewRFQSteel;
